<template>
    <KITSCombo
      propertyName="val"
      propertyID="id"
      :hasAllOption="hasAllOption"
      :firstItemValue="firstItemValue"
      v-bind:items="items"
      v-on:input="inputEvent"
      :value="selectedvalue"
      :firstItemText="this.firstItemText">
    </KITSCombo>
</template>

<script>
  import KITSCombo from "fwkits-core-presentation-vue/components/Editors/KITSCombo";

  export default {
    name: "CashHoursCombo",
    components: { KITSCombo },
    props: {
      selectedvalue: Number,
      firstItemText: {
        type: String,
        default: "Ej. Horario Apertura",
        description: "Texto del primer item"
      },
      hasAllOption: {
        type: Boolean,
        default: false,
        description: "Establece si tiene una etiqueta opcional"
      },
      hasEmptyOption: {
        type: Boolean,
        default: false,
        description: "Establece si tiene una primer opción vacía"
      },
      firstItemValue: {
          type: Number | Object,
          default: "0",
          description: "Primer item valor"
      },
    },
    data() {
      return {
        items: []
      };
    },
    methods: {
      inputEvent(val) {
        this.$emit("update:selectedvalue", val);
      },
      search() {
         for (let i = 0; i <= 24; i++) {
         this.items.push({ val: i, id: i });
        }
      },
      searchCallBack(data) {
        this.items;
      }
    },
    beforeMount: function() {
      this.search();
    }
  };
</script>